<template>
  <div class="form-group">
    <b-input-group>
      <b-input-group-text class="box px-2" v-if="id === 'telefono'"
        >+56 9</b-input-group-text
      >
      <b-form-input
        :value="value"
        :type="tipo"
        :placeholder="placeholder"
        :state="estado"
        class="form-control"
        :id="'recipient-' + id"
        :maxlength="maxlength"
        @change.native="change"
        @input.native="handler"
        @blur="blur"
        @keyup="keyup"
        :style="id === 'telefono' ? 'margin-top: 0;' : ''"
        :disabled="deshabilitar"
      />
      <b-form-invalid-feedback>{{ mensajeError }}</b-form-invalid-feedback>
    </b-input-group>
  </div>
</template>

<script>
export default {
  name: "InputTextWrapper",
  props: [
    "tipo",
    "value",
    "mensajeError",
    "placeholder",
    "estado",
    "id",
    "maxlength",
    "deshabilitar"
  ],
  methods: {
    handler(evento) {
      this.$emit("input", evento.target.value);
    },
    change(evento) {
      this.$emit("change", evento);
    },
    blur(evento) {
      this.$emit("blur", evento);
    },
    keyup(evento) {
      this.$emit("keyup", evento);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/generales/modales/InputTextWrapper.vue